export function resolveLoginStep({
  consentGiven,
  htmlConsentBoot,
  showCertificateActivate,
  certificateId,
  showCallMe,
  showRegister,
  showCard,
  showLogin,
}) {
  if (!consentGiven) {
    return htmlConsentBoot ? null : 'consent';
  }
  if (showCertificateActivate && certificateId) {
    return 'certificate';
  }
  if (showCallMe) {
    return 'callme';
  }
  if (showRegister) {
    return 'register';
  }
  if (showCard) {
    return 'card';
  }
  if (showLogin) {
    return 'login';
  }
  return null;
}
